var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _vm.loading
        ? _c("vue-loading", {
            attrs: {
              active: _vm.loading,
              "is-full-page": true,
              loader: "dots",
              color: "#70A1F0"
            },
            on: {
              "update:active": function($event) {
                _vm.loading = $event
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "resources" },
        [
          _c(
            "div",
            { staticClass: "report" },
            [
              _c("vue-good-table", {
                attrs: {
                  columns: _vm.columns[_vm.resource],
                  rows: _vm.report[_vm.resource],
                  "search-options": {
                    enabled: true,
                    skipDiacritics: true,
                    placeholder: "filter"
                  },
                  "pagination-options": {
                    enabled: true,
                    perPage: 50
                  },
                  styleClass: "vgt-table condensed"
                },
                on: { "on-row-click": _vm.selectResource },
                scopedSlots: _vm._u([
                  {
                    key: "table-row",
                    fn: function(props) {
                      return [
                        _c("span", { staticClass: "wrap" }, [
                          _c(
                            "span",
                            {
                              class: _vm.getCellClass(props.row.originalIndex)
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    props.formattedRow[props.column.field]
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ])
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("transition", [
            _c("div", { staticClass: "panel" }, [
              _c("div", { staticClass: "heading" }, [
                _c("h4", [_vm._v("Resources")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-group dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary btn-sm dropdown-toggle",
                    attrs: {
                      type: "button",
                      id: "dropdownMenuButton",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.resource) + "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu dropdown-menu-right",
                    attrs: { "aria-labelledby": "dropdownMenuButton" }
                  },
                  _vm._l(_vm.resourceTypes, function(resourceType) {
                    return _c(
                      "button",
                      {
                        key: resourceType,
                        staticClass: "dropdown-item",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.setProperty(resourceType)
                          }
                        }
                      },
                      [_vm._v(_vm._s(resourceType))]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "resources-download" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-sm btn-primary",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.downloadCSV()
                        }
                      }
                    },
                    [_vm._v("Download Report")]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.selectedResource !== null
                ? _c(
                    "div",
                    [
                      _c("ResourceDetails", {
                        attrs: {
                          resource: _vm.resource,
                          report: _vm.report,
                          selectedResource: _vm.selectedResource,
                          columns: _vm.columns,
                          supportedColumns: _vm.supportedColumns
                        },
                        on: { addCol: _vm.addCol, remCol: _vm.remCol }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0542a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0542a4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Resources.vue
// module id = null
// module chunks = 